export const isSyntheticEvent = (
  event: unknown
): event is { preventDefault: () => void } =>
  typeof event === 'object' &&
  event !== null &&
  'preventDefault' in event &&
  typeof (event as any).preventDefault === 'function';
